import React from "react";
import "./ProductScreen.css";

type Feature = {
  title: string;
  text: string;
};

type ProductScreenProps = {
  heroImageSrc: string;
  eyebrow: string;
  title: string;
  accent: string;
  description: string;
  bullets: string[];
  features: Feature[];
  ctaLabel: string;
  summaryKicker: string;
  summaryTitle: string;
  summaryText: string;
};

const ProductScreen: React.FC<ProductScreenProps> = ({
  eyebrow,
  title,
  accent,
  description,
  bullets,
  features,
  ctaLabel,
  summaryKicker,
  summaryTitle,
  summaryText,
  heroImageSrc,
}) => {
  return (
    <main className="product-screen">
      <section className="product-shell">
        <p className="product-eyebrow">{eyebrow}</p>
        <div className="product-hero">
          <div className="product-copy">
            <div className="product-microbar" style={{ background: accent }} />
            <h1 className="product-title">{title}</h1>
            <h2 className="product-description" style={{ color: accent }}>
              {description}
            </h2>
            <div className="product-chips">
              {features.slice(0, 3).map((feature) => (
                <span key={feature.title} className="product-chip">
                  {feature.title}
                </span>
              ))}
            </div>
            <ul className="product-bullets">
              {bullets.map((bullet) => (
                <li key={bullet}>
                  {bullet}
                </li>
              ))}
            </ul>
            <a href="/contact" className="product-cta" style={{ background: accent }}>
              {ctaLabel}
            </a>
          </div>

          <div className="product-visual">
            <div className="product-visual-plate" style={{ background: `linear-gradient(135deg, ${accent}18, rgba(255,255,255,0.9))` }} />
            <img src={heroImageSrc} alt="" className="product-visual-image" />
          </div>
        </div>

        <section className="product-feature-grid">
          {features.map((feature) => (
            <article key={feature.title} className="product-feature-card">
              <h3>{feature.title}</h3>
              <p>{feature.text}</p>
            </article>
          ))}
        </section>

        <section className="product-summary">
          <div className="product-summary-copy">
            <p className="product-summary-kicker" style={{ color: accent }}>
              {summaryKicker}
            </p>
            <h3>{summaryTitle}</h3>
            <p>{summaryText}</p>
          </div>
          <div className="product-summary-visual" style={{ background: `linear-gradient(135deg, ${accent}22, rgba(255,255,255,0.65))`, borderColor: `${accent}22` }} />
        </section>
      </section>
    </main>
  );
};

export default ProductScreen;
